import { z } from 'zod';

export const VulnerableCommentChoiceValues = [
  'vc_health',
  'vc_resilience',
  'vc_life_events',
  'vc_capability',
  'p_vc_health',
  'p_vc_resilience',
  'p_vc_life_events',
  'p_vc_capability',
] as const;

export const ZodVulnerableCommentChoice = z.enum(VulnerableCommentChoiceValues);

export type VulnerableCommentChoice = z.infer<typeof ZodVulnerableCommentChoice>;
